export function mergeFetchHooks(...hooks) {
  const result = {
    onRequest: [],
    onResponse: [],
    onRequestError: [],
    onResponseError: []
  };
  for (const hook of hooks) {
    for (const [key, value] of Object.entries(hook)) {
      maybePush(result[key], value);
    }
  }
  return result;
}
function maybePush(array, values) {
  if (values) {
    if (Array.isArray(values)) {
      array.push(...values);
    } else {
      array.push(values);
    }
  }
}
